import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  t,
  call,
} from "../../lib";
import { doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_ADD_TASK } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_TASK_SET_CREATE = "REQUEST_TASK_SET_CREATE";
export const doREQUEST_TASK_SET_CREATE = createDoRequestAction(REQUEST_TASK_SET_CREATE);

export const requestTaskSetCreateActionCreators = {
  doREQUEST_TASK_SET_CREATE,
};

export function* requestTaskSetCreate({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestTaskSet");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        name: v.string().exist(),
        description: v.string().optional(),
        scheduleRepeat: v.boolean(),
        scheduleDescription: v.string().optional(),
        methodId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SET_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { name, description, scheduleRepeat, scheduleDescription, methodId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/task-set-create`,
    accessToken,
    data: {
      name,
      description,
      scheduleRepeat,
      scheduleDescription,
      methodId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_SET_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/task-set-create",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doMETHOD_ADD_TASK(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_SET_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* taskSetCreateSaga() {
  yield takeEvery(REQUEST_TASK_SET_CREATE, requestTaskSetCreate);
}
